(ns practitest.frontend.forms3.run.run-details
  (:require
      [clojure.string :as str]
      [practitest.frontend.common.i18n :refer [get-translation]]
      [practitest.frontend.common.mixpanel :as mixpanel]
      [practitest.frontend.components.icons :as icons]
      [practitest.frontend.components.markdown :as markdown]
      [practitest.frontend.components.modal :as modal]
      [practitest.frontend.components2.buttons :as buttons]
      [practitest.frontend.components2.spinners :as spinners]
      [practitest.frontend.forms3.entity-form :as f3.entity-form]
      [practitest.frontend.forms3.entity-form.collapsible-section :refer [collapsible-section]]
      [practitest.frontend.forms3.entity-form.footer :as footer]
      [practitest.frontend.forms3.run.attachments :refer [run-attachment-section]]
      [practitest.frontend.forms3.run.subs :as run-subs]
      [practitest.frontend.routing.backend-routes :as broutes]
      [re-frame.core :as re-frame]
      [reagent.core :as reagent]))

(defn- run-details-modal [{:keys [test-data show? hide!]}]
  [:<>
   [modal/bootstrap-modal
    {:class "run-details-modal"
     :is-open? show?
     :on-request-close hide!
     :close-button? true
     :centered? true}
     ;;Header
     [:div.title (get-translation "run.details-view-title" "Test Details")]
     ;;Body
     [:div
      [:div.subtitle (get-translation "run.details-view-subtitle" "Test Name")]
      [:p (:name test-data)]
      [:div.subtitle (get-translation "test.step.column-header-description" "Description")]
      (when-not (str/blank? (:description test-data))
        [markdown/markdown-editor {:value         (:description test-data)
                                   :read-only?    true
                                   :preview-class :description}])]
     ;;Footer
     [buttons/button
      {:tertiary? true
       :href (broutes/get-url-view "qtest_designs#edit" {:id (:id test-data)})
       :class "go-to-test-button"
       :text (str (get-translation "run.details.link-to-test.part1" "Go to ")
                  (get-translation "test.singular" "Test")
                  " #"
                  (:display_id test-data)
                  (get-translation "run.details.link-to-test.part2" " in the library"))}]]])

(defn- disabled-fields-view [disabled-fields]
  (into [:<>]
        (map (fn [{:keys [label value]}]
               [:div.g2-field-container
                [:span.m-label label]
                [:input.m-input
                 {:value     (or value "")
                  :disabled  true
                  :read-only true}]])
             disabled-fields)))

(defn- execution-output-view [output]
  (when (seq output)
    [:div.run-execution-output
     [:span.m-label (get-translation "run.execution-output" "Execution Output")]
     [:div.run-step-field.readonly
      [markdown/markdown-editor {:value output :read-only? true}]]]))

(defn run-details-card [form-id]
  (let [show-modal?     (reagent/atom false)
        expanded?       (reagent/atom false)
        on-field-change #(mixpanel/track "Run Form Actions" {"Action" "Run Details Field Edited"})]
    (fn [_form-id {:keys [entity-type base-entity edit-permissions? edit-locked?] :as form-props}]
      (let [test-data         @(re-frame/subscribe [::run-subs/parent-test])
            disabled-fields   (:disabled_fields base-entity)
            fields-loading?   @(re-frame/subscribe [::f3.entity-form/fields-loading? form-id])
            effective-props   (cond-> form-props
                                edit-locked? (assoc :edit-permissions? false))
            has-attachments?  (boolean (seq @(re-frame/subscribe [::run-subs/run-attachments])))]
        [:<>
         [run-details-modal {:test-data test-data
                             :show?     @show-modal?
                             :hide!     #(reset! show-modal? false)}]
         [collapsible-section
          {:entity-type    entity-type
           :storage-key    "run-details-section"
           :class          "run-details-panel"
           :default-collapsed? true
           :title          (get-translation "run.details" "Run Details")
           :on-toggle      #(mixpanel/track "Run Form Actions"
                              {"Action" (str "Run Details" (if % " Collapsed" " Expanded"))})
           :header-actions [:<>
                            [buttons/button
                             {:tertiary? true
                              :on-click  #(do
                                            (mixpanel/track "Run Form Actions" {"Action" "View Test Details Clicked"})
                                            (reset! show-modal? true))
                              :class     "run-details-button"
                              :text      (get-translation "run.details.link" "View Test Details")
                              :icon      [icons/mux-test-library]}]
                            [:div.form-header-actions
                             [f3.entity-form/configure-fields-menu entity-type]
                             [footer/standard-save-button effective-props footer/standard-save-form!]]]}
          (if fields-loading?
            [:div.centered-spinner
             [spinners/mux-spinner {:size :table}]]
            (let [section-fields (f3.entity-form/clean-section-fields-from-integration-fields
                                   effective-props (:general-info f3.entity-form/sections-keys))]
              [:<>
               [:div.run-details-grid
                {:class (when @expanded? "expanded")}
                [execution-output-view (:automated_output base-entity)]
                (when (seq disabled-fields)
                  [disabled-fields-view disabled-fields])
                [f3.entity-form/fields-view
                 (assoc effective-props :on-field-change on-field-change)
                 section-fields]]
               (when has-attachments?
                 [:div.run-details-attachments
                  [run-attachment-section {:entity-type       :run
                                           :entity-id         (:id base-entity)
                                           :attachable-type   "QtestRun"
                                           :edit-permissions? edit-permissions?
                                           :edit-locked?      edit-locked?
                                           :upload-locked?    true}]])
               (when (> (count section-fields) 1)
                 [:div.toggle-expand
                  [:span.text
                   {:on-click #(do
                               (mixpanel/track "Run Form Actions"
                                               {"Action" (str "Run Details Fields" (if @expanded? " Collapsed" " Expanded"))})
                               (swap! expanded? not))}
                   (if @expanded?
                     (get-translation "generic.button.show-less" "Show less")
                     [:<> [icons/svg-plus-lg] (get-translation "generic.button.show-all" "Show all")])]])]))]]))))
